import './ZoomPanel.scss';

import React, { useRef, useState } from 'react';
import { Panel, useReactFlow, useViewport } from 'reactflow';
import IconPlus from 'pages/FlowBuilder/assets/icons/IconPlus';
import IconMinus from 'pages/FlowBuilder/assets/icons/IconMinus';

const MAIN_CLASS = 'zoom-panel';
const CLASSES = {
  ZOOM_LEVEL: `${MAIN_CLASS}__zoom-level`,
  ICON: `${MAIN_CLASS}__icon`,
};

function ZoomPanel() {
  const { zoomTo } = useReactFlow();
  const { zoom } = useViewport();
  const zoomLevelInputRef = useRef<HTMLInputElement>(null);
  const [zoomLevel, setZoomLevel] = useState<number | ''>(Math.floor(zoom * 100));
  const [isZoomLevelInputFocused, setIsZoomLevelInputFocused] = useState(false);

  const handleFocus = () => {
    setZoomLevel(Math.floor(zoom * 100));
    setIsZoomLevelInputFocused(true);
  };
  const handleBlur = () => {
    zoomTo(zoomLevel ? zoomLevel / 100 : zoom);
    setIsZoomLevelInputFocused(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value !== '' && !Number.isInteger(Number(value))) {
      return;
    }
    setZoomLevel(value === '' ? '' : Number(value));
  };

  return (
    <Panel className={MAIN_CLASS} position="bottom-right">
      <button
        onClick={() => {
          zoomTo(zoom - 0.25);
        }}
      >
        <IconMinus customClassName={CLASSES.ICON} />
      </button>
      <input
        ref={zoomLevelInputRef}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}
        className={CLASSES.ZOOM_LEVEL}
        size={5}
        value={isZoomLevelInputFocused ? zoomLevel : Math.floor(zoom * 100) + '%'}
      />
      <button
        onClick={() => {
          zoomTo(zoom + 0.25);
        }}
      >
        <IconPlus customClassName={CLASSES.ICON} />
      </button>
    </Panel>
  );
}

export default ZoomPanel;
